import StaticPageLayout from './StaticPageLayout';

export default function ContactPage() {
  return <StaticPageLayout title="Kontakte"></StaticPageLayout>;
}
